module.exports = __webpack_public_path__ + "assets/img/13-m.2db126d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/13-m.jpg
// module id = d2v8
// module chunks = 0